export default "__VITE_ASSET__6c2cd252__"